import React, { useState, useEffect } from "react";
import axios from "axios";

const EmployeesSpeak = () => {
  const [employees, setEmployees] = useState([]);
  
    useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/careers`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setEmployees(events.employees);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);

  return (
    <div className="bg-blue-100 py-10">
      <h2 className="text-2xl font-bold text-center mb-6">Employees Speak</h2>
      <div className=" mx-auto grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 px-4">
        {employees.map((employee, index) => (
          <div key={index} className="relative group overflow-hidden rounded-xl shadow-lg">
            {/* Employee Image */}
            <img
              // src={`${process.env.REACT_APP_COURSE_API_BASEURL}${employee.image}`}
              src={employee?.image}
              alt={employee?.name}
              className="w-full h-80 object-cover transition-transform duration-300 group-hover:scale-110"
            />

            {/* Name & Position (Always Visible) */}
            <div className="!absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 p-4">
              <h3 className="text-white text-lg font-bold">{employee.name}</h3>
              <p className="text-white text-sm">{employee.position}</p>
            </div>

            {/* Description (Visible on Hover) */}
            {employee.description && (
              <div className="!absolute inset-0 bg-black bg-opacity-70 text-white flex items-center justify-center text-center p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p>{employee.description}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmployeesSpeak;
